import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import { FaArrowRight } from 'react-icons/fa6'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

const Mission = () => {

    const location = useLocation();
    console.log("locationMission", location?.pathname);

    return (
        <>
            <Header />
            <Helmet>
                <title>Our Mission | iLine Logistics - Leading Logistics app in Delhi NCR</title>
                <meta name="description" content="Explore the mission of iLine Logistics. Committed to providing top-notch logistics and delivery services in Delhi, we aim to exceed customer expectations with industry-best pricing and AI-driven efficiency." />
                <link rel="canonical" href={`https://iline.ai${location.pathname}`} />
            </Helmet>
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft">
                        <h2>Our Mission</h2>
                    </div>
                    <div className="osRight">
                        <p style={{ marginBottom: "0px" }} >Our mission is to contribute to a cleaner planet by empowering companies to shift their fleets toward sustainability. Our smart solution enables businesses to make the transition to electric vehicles (EVs) and reduce their carbon footprint, while also reaping the benefits of EVs such as lower costs and improved performance.</p>
                        <p style={{ marginTop: "0px" }}><strong>Reducing CO2 Emission</strong> is becoming increasingly important for companies. By partnering with us and shifting your fleet to EVs, you can demonstrate your commitment to sustainability and contribute to a better future. ILINE is aiming to lead the way towards
                            achieving India pledge towards Paris Agreement goals by transforming India’s goods transportation to Electric Vehicles (EV).
                        </p>
                    </div>
                </div>
            </section>
            {/* <section className="HowWeHelp">
                 <div className="section-title">
    <h2>
      How we help businesses <br /> across the world.
    </h2>
  </div> 
                <div className="container">

                    <div class="HowLine"><div class="CenterLine"></div><span class="CenterLineImg"><img src="./static/media/main_circle.a19149d5b212e8bb9e4e05c4393bd04b.svg" /></span><span class="Left"><img src="./static/media/small_circle.bf911f3e471db3c26ca62cfeb01730e2.svg" /></span><span class="Right"><img src="./static/media/small_circle.bf911f3e471db3c26ca62cfeb01730e2.svg" /></span><span class="Center"><img src="./static/media/small_circle.bf911f3e471db3c26ca62cfeb01730e2.svg" /></span></div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="HwhBox">
                                <h2>Our Culture
                                </h2>
                                <p>
                                    At iLine.ai, we thrive on innovation, collaboration, and purpose. Our work culture reflects our passion for creating a greener planet and empowering businesses with sustainable solutions.
                                </p>
                                <p><strong>Innovative Spirit:</strong> We foster creativity and embrace cutting-edge ideas to revolutionize logistics.</p>
                                <p><strong>Collaboration First:</strong> We believe in teamwork, encouraging open communication and shared success.</p>
                                <p><strong>Sustainability Mindset:</strong> Every decision we make aligns with our mission to reduce environmental impact. </p>
                                <p><strong>Growth-Oriented:</strong> We support personal and professional growth, creating a dynamic and fulfilling work environment. </p>

                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="HwhBox text-center">
                                <h2>Our Commitment
                                </h2>
                                <p><strong>To Our Planet:</strong> We are steadfast in reducing carbon footprints by delivering eco-friendly logistics services with our EV fleet.</p>
                                <p><strong>To Our Partners:</strong> Providing dependable, efficient, and customized logistics solutions that add value to your business. </p>
                                <p><strong>To Our Communities:</strong> Building cleaner, healthier cities through sustainable practices and environmental stewardship. </p>
                                <p><strong>To Innovation:</strong> Continuously enhancing our technology to provide smarter and more efficient logistics solutions. </p>
                                <p><strong>To Growth:</strong> Empowering our team, partners, and stakeholders to grow with us as we lead the charge towards a sustainable future. </p>
                                <p>At iLine.ai, we’re not just redefining logistics—we’re building a culture and community that’s committed to making a lasting positive impact. Let’s move forward together. </p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="HwhBox text-end">
                                <h2>Our Values
                                </h2>
                                <p><strong>Sustainability:</strong> The foundation of our operations and our commitment to a greener future. </p>
                                <p><strong>Integrity:</strong> Transparency and trust guide all our actions and relationships. </p>
                                <p><strong>Innovation:</strong> Continuously pushing boundaries with technology and creativity. </p>
                                <p><strong>Customer Focus:</strong> Prioritizing our partners’ success with tailored and reliable solutions. </p>
                                <p><strong>Excellence:</strong> Setting and achieving the highest standards in everything we do. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <section className='WhyLogiServices ParaImgCus'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <div className="WhyLogiLeft pe-lg-5">
                                <h2>Our Culture
                                </h2>
                                <p>At iLine.ai, we thrive on innovation, collaboration, and purpose. Our work culture reflects our passion for creating a greener planet and empowering businesses with sustainable solutions. </p>
                                <p><strong>Innovative Spirit:</strong> We foster creativity and embrace cutting-edge ideas to revolutionize logistics. </p>
                                <p><strong>Collaboration First:</strong> We believe in teamwork, encouraging open communication and shared success. </p>
                                <p><strong>Sustainability Mindset:</strong> Every decision we make aligns with our mission to reduce environmental impact. </p>
                                <p><strong>Growth-Oriented:</strong> We support personal and professional growth, creating a dynamic and fulfilling work environment.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <div className="WhyLogiRight ImgHeight">
                                <figure><img src={require('../../assets/images/img-3.jpg')} alt='img' /></figure>
                            </div>
                        </div>
                        <div className="col-lg-6 order-3">
                            <div className="WhyLogiRight ImgHeight">
                                <figure><img src={require('../../assets/images/mission/mission-11.jpg')} alt='img' /></figure>
                            </div>
                        </div>
                        <div className="col-lg-6 order-4">
                            <div className="WhyLogiLeft ParaMargin ps-lg-5">
                                <h2>Our Values
                                </h2>
                                <p>
                                    Sustainability: The foundation of our operations and our commitment to a greener future.
                                </p>
                                <p>Integrity: Transparency and trust guide all our actions and relationships. </p>
                                <p>Innovation: Continuously pushing boundaries with technology and creativity. </p>
                                <p>Customer Focus: Prioritizing our partners’ success with tailored and reliable solutions. </p>
                                <p>Excellence: Setting and achieving the highest standards in everything we do. </p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-5 order-6">

                            <div className="WhyLogiLeft ParaMargin pe-lg-5">
                                <h2>Our Commitment
                                </h2>
                                <p><strong>To Our Planet:</strong> We are steadfast in reducing carbon footprints by delivering eco-friendly logistics services with our EV fleet. </p>
                                <p><strong>To Our Partners:</strong> Providing dependable, efficient, and customized logistics solutions that add value to your business. </p>
                                <p><strong>To Our Communities:</strong> Building cleaner, healthier cities through sustainable practices and environmental stewardship. </p>
                                <p><strong>To Innovation:</strong> Continuously enhancing our technology to provide smarter and more efficient logistics solutions. </p>
                                <p><strong>To Growth:</strong> Empowering our team, partners, and stakeholders to grow with us as we lead the charge towards a sustainable future. </p>
                                <p>At iLine.ai, we’re not just redefining logistics—we’re building a culture and community that’s committed to making a lasting positive impact. Let’s move forward together. </p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-6 order-5">
                            <div className="WhyLogiRight ImgHeight">
                                <figure><img src={require('../../assets/images/mission/mission-13.jpg')} alt='img' /></figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className="WhyLogiServices">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="WhyLogiLeft mb-0">
                                <h2>Why Logi Services?
                                </h2>
                                <p>Our mission statement is simplicity itself. To constantly exceed customer expectations by providing superior freight forwarding and global transportation solutions including air, ocean, and customs brokerage and logistics services.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="WhyLogiRight mb-0">
                                <p>Our team of professionals is totally committed to provide you a service that far exceeds your expectations. We put forward a tremendous extra effort everyday to give this level and quality of service and we are always striving to deliver the most efficient and effective solutions in the industry by utilizing state of the art technologies, highly trained friendly and experience staff as well as a solid infrastructure.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <section className='WhyLogiServices'>
                <div className="container">
                    <div className="row">

                        <div className="col-lg-6">
                            <div className="WhyLogiLeft d-flex flex-column align-items-end justify-content-center pt-5 pe-5">
                                <h2>Our Drive and Vision
                                </h2>
                                <p className='text-end'>
                                    We approach every need of our customer with utmost flexibility because we concentrate not on the processes but the end result - proper delivery of the shipment.
                                </p>
                                <a href="javascript:void(0);">Read More <FaArrowRight /></a>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="WhyLogiRight ImgHeight">
                                <figure><img src={require('../../assets/images/mission/mission-img-1.webp')} /></figure>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="WhyLogiRight ImgHeight">
                                <figure><img src={require('../../assets/images/mission/mission-img-1.webp')} /></figure>
                            </div>
                        </div>
                        <div className="col-lg-6">

                            <div className="WhyLogiLeft pt-3 ps-4 d-flex flex-column justify-content-center h-100">
                                <h2>Why Logi Services?
                                </h2>
                                <p>Our goal is to provide a competitive advantage to our clients by producing a reliable and personalized logistical support system. We strongly support best practice sharing across our operations around the world and across various industrial sectors to be a leader, the strongest and most trusted company both nationally and internationally in the field of Shipping, Logistics and Relocations.</p>
                                <img src={require('../../assets/images/mission/sign-img.jpg')} className='SignImg' />
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <Footer />

        </>
    )
}

export default Mission
